export default {"src":"/_next/static/media/always-know-what-you-pay.40d5fe56.svg","height":36,"width":22,"blurWidth":0,"blurHeight":0};